import axiosConfig from "./axiosConfig";
import { GprRule, SiteHealthConfig } from "./getSiteHealthConfig";

export interface PutSiteHealthConfigRequest {
  alertingEnabled?: boolean;
  unreliableConnection?: boolean;
  lateDataThresholdSeconds?: number;
  contractedAvailability?: number | null;
  /** @deprecated use gprRule + designedPrPct */
  contractedGpr?: number | null;
  designedPrPct?: number | null;
  gprRule?: GprRule | null;
  weatherActualsEnabled?: boolean;
  maxImportAllowedKw?: number | null;
  maxImportEnforcedKw?: number | null;
}

const putSiteHealthConfig = async (
  authToken: string,
  siteId: string,
  config: PutSiteHealthConfigRequest
): Promise<SiteHealthConfig> => {
  const { data } = await axiosConfig.put(
    `/site/${siteId}/health/config`,
    config,
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default putSiteHealthConfig;
